import styled from 'styled-components';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.label`
  display: inline-flex;
  cursor: pointer;
`;

interface TrackProps {
  isChecked: boolean;
}

export const Track = styled.input<TrackProps>`
  appearance: none;
  -webkit-appearance: none;

  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;

  border: none;
  border-radius: ${radius.full};
  background-color: ${colors.surfaceContainerHighest};
  cursor: pointer;
  transition: background-color 200ms;

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: ${radius.full};
    background-color: ${colors.onSurfaceVariant};
    transition: transform 200ms, background-color 200ms;
  }

  &:checked {
    background-color: ${colors.primaryContainer};
  }

  &:checked::before {
    transform: translateX(18px);
    background-color: ${colors.primary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
